export default  {
    _listeners: {},
    _iframes: {},
    /**
    * Install the PostMessage class.
    *
    * @param {Object} app 
    * @return {this} 
    */
    install(app) {
        console.log(">>>>>>>>>>>>>>>>>>>>>>> postMessage.install...");
        window.addEventListener("message", (message) => {
            if (this._listeners[message.data.action])
                this._listeners[message.data.action].forEach(func => func(message.data))
        })
        this.addIframe('top', top);
        if (app.prototype) //vue 2
            app.prototype.$postMessage = app.postMessage = this
        if (app.config?.globalProperties) //vue 3
            app.config.globalProperties.$postMessage = this
        return this
    },
    /**
    * on - listening to a constant
    *
    * @param {String} action 
    * @param {function} func 
    * @return {void}
    */
    on(action, func) {
        if (!this._listeners[action]) {
            this._listeners[action] = []
        }
        this._listeners[action].push(func)
    },
    /**
    * add new iframe.
    *
    * @param {String} uid 
    * @param {Object} element 
    * @return {void}
    */
    addIframe(uid, element) {
        this._iframes[uid] = element
    },
    /**
    * sent message.
    *
    * @param {String} action 
    * @param {Object} obj 
    * @param {String} uid 
    * @return {void}
    */
    message(action, obj, uid = 'top') {
        this._iframes[uid].postMessage({ action: action, ...obj }, "*")
    }
}